import React from "react";
import Link from "next/link";
import FadeInAnimation from "../../Common/FadeInAnimation";
import { useTranslations } from '../../../locales/useTranslations';
import { BiChevronRight, BiMobile, BiLogoChrome, BiBuildingHouse, BiBookReader, BiServer } from "react-icons/bi";

const MetabaseWeitereServices = () => {
  const { t } = useTranslations();
  return (
    <>
      <div className="services-area ptb-70">
        <div className="container">
          <div className="section-title text-left">
            <span className="sub-title">{t("metabase_weitereServices_subTitle")}</span>
            <h2>{t("metabase_weitereServices_title")}</h2>
          </div>

          <FadeInAnimation direction="up" delay={100}>
            <div className="container">
              <div className="row">

                <div className="col-sm-6">
                  <Link href="/it-consulting" className="read-more">
                    <div className="features-box">
                      <div className="icon">

                        <BiBuildingHouse />
                      </div>
                      <h3>{t("metabase_weitereServices_title2")}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t("metabase_weitereServices_description2") }} />
                      <span className="features-box-action">{t("metabase_weitereServices_readMore")}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiBuildingHouse />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/kuenstliche-intelligenz/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiServer />
                      </div>
                      <h3>{t("metabase_weitereServices_title3")}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t("metabase_weitereServices_description3") }} />
                      <span className="features-box-action">{t("metabase_weitereServices_readMore")}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiServer />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/app-development/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiMobile />
                      </div>
                      <h3>{t('powerBi_weitereServices_title5')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('powerBi_weitereServices_description5') }} />
                      <span className="features-box-action">{t('powerBi_weitereServices_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiMobile />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/web-development/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoChrome />
                      </div>
                      <h3>{t('powerBi_weitereServices_title6')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('powerBi_weitereServices_description6') }} />
                      <span className="features-box-action">{t('powerBi_weitereServices_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoChrome />
                      </div>
                    </div>
                  </Link>
                </div>

              </div>
            </div>
          </FadeInAnimation>

        </div>
      </div>
    </>
  );
};

export default MetabaseWeitereServices;
